import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useStateValue } from 'context/app';
import { getCityDetails } from 'containers/Account/actions';
import dateFormat from 'date-fns/format';
import CitySelect from 'containers/Checkout/views/AddAddress/CitySelect';
import parseISO from 'date-fns/parseISO';

import { getCitiesAndAreas, reloadAddress } from 'containers/Checkout/actions';
// import parseISO from 'date-fns/parseISO';
import './index.scss';
import {
  COUNTRY,
  COUNTRY_BH,
  COUNTRY_KSA,
  COUNTRY_KWT,
  COUNTRY_QA,
  COUNTRY_UAE,
  CURRENT_LANG_PREFIX,
  IS_ARABIC
} from 'constants/index';
import { translate } from 'constants/language';
import ReactSlidingPane from 'components/libs/SlidePane';
import { getCustomerId } from 'utils/user';
import { getDeliverySlaCityId, getSelectedCityData } from 'utils/address';
import { isBrowser } from 'react-device-detect';
import { getStoreId, getStoreCurrentTimeDiff } from 'utils/';

export default ({ isBagPage = false, setSLADate = () => {} }) => {
  const [selectedProvinces, selectProvince] = useState({});
  const {
    account: [accountState, accountDispatch],
    shipping: [shippingState, shippingDispatch]
  } = useStateValue();
  const [timeDiffString, setTimeDiff] = useState('');

  const {
    config: { deliverySlaConfigs } = {},
    cityDetails = {}
  } = accountState;

  const { provincesNew: provinceData } = shippingState;

  const {
    addresses: customerAddressData = [],
    defaultCityDetails = {}
  } = shippingState;
  const [defaultAddressData, setDefaultAddressData] = useState({});
  const [savedCityChecked, setSavedCityCheck] = useState(false);
  const [selectedCityId, setCityId] = useState(null);

  // const [selectedCityId, setCityId] = useState(null);
  const uaeProvince = {
    name: IS_ARABIC ? 'الإمارات العربية المتحدة' : 'UAE',
    id: '577'
  };

  const kWProvince = {
    name: IS_ARABIC ? 'الكويت' : 'Kuwait',
    id: '610'
  };

  const bHProvince = {
    name: IS_ARABIC ? 'البحرين‎' : 'Bahrain',
    id: '611'
  };

  const qAProvince = {
    name: IS_ARABIC ? 'قطر' : 'Qatar',
    id: '613'
  };

  const provinceMap = {
    [COUNTRY_KWT]: kWProvince,
    [COUNTRY_UAE]: uaeProvince,
    [COUNTRY_QA]: qAProvince,
    [COUNTRY_BH]: bHProvince
  };

  const citySelectProvince = { province: provinceMap[COUNTRY] };

  useEffect(() => {
    reloadAddress({}, shippingDispatch);
    // getDefaultAddress(accountDispatch);
    getCitiesAndAreas({}, shippingDispatch);
    // getCitiesAndAreasNew({}, shippingDispatch);
  }, []);

  const handleAddressCity = finalCity => {
    if (finalCity) {
      getCityDetails(
        {
          citySearchKey: finalCity,
          defaultCityId: defaultCityDetails.id,
          updateLocal: true
        },
        accountDispatch
      );
    }
  };

  useEffect(() => {
    if (
      provinceData &&
      defaultCityDetails &&
      defaultCityDetails.id &&
      !savedCityChecked
    ) {
      getDeliverySlaCityId().then(pdpCityId => {
        if (pdpCityId) {
          setCityId(pdpCityId);
          return '';
        }
        const customerId = getCustomerId();
        setCityId(defaultCityDetails.id);
        if (customerId) {
          if (customerAddressData && customerAddressData.length) {
            let finalCity = '';
            const filteredAddress = customerAddressData.filter(
              adrs => adrs.enabled
            );
            if (filteredAddress.length) {
              const defaultCustomerAddress =
                filteredAddress.find(adrs => adrs.defaultAddress) || {};
              const finalAddress = defaultCustomerAddress.city
                ? defaultCustomerAddress
                : filteredAddress[0];
              const finalCityData = getSelectedCityData({
                selectedAddress: finalAddress,
                addressData: provinceData
              });
              finalCity = finalCityData.id;
              // setCityId(finalCityData.id);
            }
            handleAddressCity(finalCity);
            setSavedCityCheck(true);
          }
        }
        return '';
      });
    }
  }, [customerAddressData, defaultCityDetails, provinceData, savedCityChecked]);
  useEffect(() => {
    if (cityDetails.id && deliverySlaConfigs) {
      let slaDate = cityDetails.estimated_date
        ? dateFormat(
            new Date(parseISO(cityDetails.estimated_date)),
            'EEE, do LLL'
          )
        : '';
      if (!slaDate) {
        const factor =
          deliverySlaConfigs && deliverySlaConfigs.use_min_sla
            ? cityDetails.min_sla
            : cityDetails.max_sla;

        slaDate = dateFormat(
          new Date(new Date().getTime() + 86400000 * factor),
          'EEE, do LLL'
        );
      }

      const timezone =
        deliverySlaConfigs.timezone &&
        deliverySlaConfigs.timezone[getStoreId()];
      let cutOffStr = '';
      if (!cityDetails.cutoff_time_excluded && cityDetails.cut_off_time) {
        const { hrsDiff, minDiff } = getStoreCurrentTimeDiff(
          cityDetails.cut_off_time,
          timezone
        );

        if (hrsDiff || minDiff) {
          cutOffStr = `${translate('When you order in')} ${
            hrsDiff ? `${hrsDiff} ${translate('hours')}` : ''
          } ${minDiff ? `${minDiff} ${translate('mins')}` : ''}`;
        }
      }
      setTimeDiff(cutOffStr);

      setDefaultAddressData({
        ...cityDetails,
        slaDate
      });
      setSLADate(slaDate);
    }
  }, [cityDetails]);

  useEffect(() => {
    if (selectedCityId)
      getCityDetails(
        {
          citySearchKey: selectedCityId,
          defaultCityId: defaultCityDetails.id,
          updateLocal: savedCityChecked
        },
        accountDispatch
      );
  }, [selectedCityId]);

  const titles = {
    province: translate('Province'),
    city: translate('City'),
    area: translate('Area')
  };
  const [provinceModalValue, showProvinceModal] = useState(false);
  const closeProvinceModal = () => {
    showProvinceModal(false);
  };
  const navigationOrder = ['province', 'city'];
  const [type, selectAddressType] = useState(
    COUNTRY === COUNTRY_KSA ? 'province' : 'city'
  );
  const onNext = () => {
    const index = navigationOrder.indexOf(type);
    if (index === 1) {
      closeProvinceModal();
    } else {
      selectAddressType(navigationOrder[index + 1]);
    }
  };
  const onBack = step => {
    const index = navigationOrder.indexOf(step);
    selectAddressType(navigationOrder[index]);
  };

  const onSelectProvince = ({ id, name }, selectType) => {
    const newProvinces = {
      ...selectedProvinces,
      [selectType]: { id, name }
    };
    if (
      selectType === 'province' &&
      newProvinces.city &&
      !newProvinces.city.id
    ) {
      newProvinces.city.id = '';
      newProvinces.city.name = '';
      newProvinces.area.id = '';
      newProvinces.area.name = '';
    }
    if (selectType === 'city') {
      if (newProvinces.area && !newProvinces.area.name) {
        newProvinces.area.id = '';
        newProvinces.area.name = '';
      }
      getCityDetails(
        {
          country: COUNTRY,
          citySearchKey: newProvinces.city.id,
          updateLocal: true
        },
        accountDispatch
      );
    }
    selectProvince(newProvinces);
  };

  return (
    <If
      condition={
        deliverySlaConfigs &&
        deliverySlaConfigs.enable_feature &&
        defaultAddressData &&
        defaultAddressData.name_en
      }
    >
      <Choose>
        <When condition={isBagPage}>
          <If condition={defaultAddressData.slaDate}>
            <div className="flex middle-xs center-xs fs-11 lh-16 ls-04 c-main-black pt-8 pb-8 bg-white mb-8">
              <div>&nbsp;{translate('Delivery to')}&nbsp;</div>
              <div
                className="fw-6 bb-dark-gray"
                role="button"
                onClick={() => showProvinceModal(true)}
                onKeyPress={() => showProvinceModal(true)}
              >
                {CURRENT_LANG_PREFIX === 'ar'
                  ? defaultAddressData.name_ar
                  : defaultAddressData.name_en}
              </div>
              <div className="fw-6">&nbsp;{translate('by')}&nbsp;</div>
              <div className="fw-6 en-font">{defaultAddressData.slaDate}</div>
            </div>
          </If>
        </When>
        <Otherwise>
          <div
            className={classnames('flex middle-xs fs-12 c-dark-gray', {
              'mb-16': isBrowser,
              'c-greyish-brown': !isBrowser
            })}
            style={
              isBrowser
                ? {
                    color: deliverySlaConfigs.sla_colors.pdp_text
                  }
                : {}
            }
          >
            <div>
              <If condition={defaultAddressData.slaDate}>
                <div
                  className={classnames(
                    isBrowser ? 'fs-14 lh-18 ls-064' : 'lh-14'
                  )}
                >
                  {translate('Delivery by')}&nbsp;
                  <span className="fw-6 en-font">
                    {defaultAddressData.slaDate}
                  </span>
                </div>
                <If condition={timeDiffString}>
                  <div className="c-dark-gray">{timeDiffString}</div>
                </If>
              </If>
            </div>
            <div
              className={classnames(
                'fw-6 ml-auto bb-dark-gray',
                isBrowser ? 'fs-14 lh-14 ls-12' : ''
              )}
              role="button"
              onClick={() => showProvinceModal(true)}
              onKeyPress={() => showProvinceModal(true)}
            >
              {CURRENT_LANG_PREFIX === 'ar'
                ? defaultAddressData.name_ar
                : defaultAddressData.name_en}
            </div>
          </div>
          <hr
            className={classnames(' ', {
              'h-8 ml-n-15 mr-n-15 bg-yellow-gray-300': !isBrowser,
              'bg-very-light-pink-gray': isBrowser
            })}
          />
        </Otherwise>
      </Choose>
      <If
        condition={
          shippingState &&
          shippingState.provinces &&
          shippingState.provinces[COUNTRY.toUpperCase()]
        }
      >
        <If condition={provinceModalValue}>
          <ReactSlidingPane
            className={classnames('z-100 ', { 'br-l-6': isBrowser })}
            isOpen={true}
            from="bottom"
            width="100%"
            height={isBrowser ? '100%' : ''}
            onRequestClose={closeProvinceModal}
            hasHeader={false}
          >
            <div>
              <CitySelect
                title={titles[type]}
                type={type}
                onNext={onNext}
                onBack={onBack}
                provinces={shippingState.provinces[COUNTRY.toUpperCase()]}
                closeProvinceModal={closeProvinceModal}
                selectProvince={onSelectProvince}
                selectedProvinces={
                  COUNTRY === COUNTRY_KSA
                    ? selectedProvinces
                    : citySelectProvince
                }
                isSla={true}
              />
            </div>
          </ReactSlidingPane>
        </If>
      </If>
    </If>
  );
};
